module.exports = __webpack_public_path__ + "img/edit.97d77045.svg";